import TermsSelect from '@/components/TermsSelect'
import { invitation } from '@/services/member/member'
import { ModalForm } from '@ant-design/pro-form'
import { useRequest } from 'ahooks'
import { AutoComplete, Form, Input, message, Select, Space } from 'antd'
import React, { memo, useContext, useMemo, useState } from 'react'
import { OrganizationContext } from '../../index'
import { IconFont } from '@/components/IconFont'
import { queryUsers } from '@/services/user/user.service'
import OrbitAvatar from '@/components/OrbitAvatar'
import { orgAccountTypes } from '@/utils/constants'

interface InvitationMemberProps {
  trigger: JSX.Element
}

export default memo<InvitationMemberProps>(function InvitationMember(props) {
  const [form] = Form.useForm()
  const { trigger, ...other } = props
  const orgData = useContext(OrganizationContext).orgData!
  const { run } = useRequest(invitation, { manual: true })
  const [options, setOptions] = useState<any[]>([])
  const [selectedOption, setSelectedOption] = useState<any>(null)

  const { run: runQuery } = useRequest(queryUsers, {
    manual: true,
    debounceWait: 300,
    onSuccess: (users = []) => {
      const userOptions: any[] = users.map((item) => ({
        value: item.email,
        label: (
          <Space>
            <OrbitAvatar avatar={item.avatar} name={item.fullName} />
            <span>{item.email}</span>
          </Space>
        )
      }))
      setOptions(userOptions)
    }
  })

  const accountTypes = useMemo(() => {
    return orgAccountTypes.filter(item => item.value !== 'OWNER')
  }, [])

  return (
    <ModalForm
      {...other}
      form={form}
      trigger={trigger}
      width={500}
      title='Invitation Member'
      modalProps={{
        maskClosable: false
      }}
      onVisibleChange={(visible: boolean) => {
        visible && form.resetFields()
      }}
      onFinish={async (values) => {
        const options = { ...values, orgId: orgData.id }
        if (selectedOption?.email) {
          options.email = selectedOption.email
        }
        if (!options.email) {
          message.warning('No user information found')
          return false
        }
        await run(options)
        return true
      }}
    >
      <Form.Item
        label='Search users by name, email'
        name='email'
        rules={[
          { required: true, message: 'Please enter email address' },
          { type: 'email', message: 'Invalid email format' }
        ]}
      >
        <AutoComplete
          options={options}
          onSearch={(value: string) => {
            setSelectedOption(null)
            runQuery(value)
          }}
          onSelect={(_, option) => {
            setSelectedOption(option)
          }}
        >
          <Input type='email' prefix={<IconFont type={'icon-search'} />} />
        </AutoComplete>
      </Form.Item>

      <Form.Item name='accountType' label="Account Type" required>
        <Select options={accountTypes} />
      </Form.Item>

      <Form.Item label='Terms' name='termsId' rules={[{ required: true, message: 'Please select terms' }]}>
        <TermsSelect orgId={orgData.id} />
      </Form.Item>
    </ModalForm>
  )
})
